<template>
  <div class="pardata_box">
    <p class="back_box" @click="back()">
      <img src="../../../../static/images/back.png" alt="">
      返回上一页</p>
    <h2>案件详细进度</h2>
    <div class="case_box">
      <ParheaderVue :caseid="caseid" :token="token" />
      <Parinf :dataArr="objdata" :token="token" />
    </div>
  </div>
</template>

<script>
  import {
    getCasedetail,
    caseProgress
  } from '@/views/axios/api.js'
  import ParheaderVue from "../../par/parheader.vue";
  import Parinf from "../../par/Parinf.vue";
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        inf: {},
        casenumber: "",
        showcooperaterDialogVisible:false,
        usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
        token: JSON.parse(window.localStorage.getItem("data")).data,
        caseid: this.$route.query.id,
        objdata: {},
        jbData:{},
        serviceId:'',
        opPhotoUrls:[]
      }
    },
    components: {
      ParheaderVue,
      Parinf
    },
    methods: {
       setTime(str) {
        return constants.time(str)
      },
      back() {
        this.$router.go(-1)
      },
      setData(obj,id,arr){
        this.jbData=JSON.parse(obj)
        this.serviceId=id;
        this.opPhotoUrls=JSON.parse(arr)
      }
    },

    mounted() {
    },

  };
</script>


<style scoped>
  a {
    text-decoration: none;
    color: #00abfa;
  }

  .data_wrap {
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
  }

  .data_wrap h3 {
    font-size: 18px;
    color: #333;
    margin: 10px 0;
  }

  .data_wrap ul {
    width: 100%;
    overflow: hidden;
  }

  .data_wrap ul li {
    line-height: 40px;
    font-size: 16px;
    float: left;
    margin-right: 20px;
  }

  .data_wrap ul li:last-child textarea {
    width: 80%;
    height: 80px;
    border: 0;
    border: 1px solid #d9ddde;
    border-radius: 5px;
    font-size: 15px;
    margin-top: 15px;
  }

  .data_wrap ul li:last-child span,
  .data_wrap ul li:last-child textarea {
    float: left;
  }

  .req_box>p {
    margin-top: 15px;
    line-height: 45px;
    text-align: left;
  }

  .box_req ul li b {
    font-size: 14px;
  }

  .org_box {
    font-size: 16px;
    box-sizing: border-box;
    padding-left: 15px;
  }

  .org_box p {
    line-height: 40px;
    color: #333;
  }

  .acc_box {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .acc_box>p {
    color: #333;
    line-height: 40px;
    font-size: 15px;
  }

  .acc_box ul li {
    display: inline-block;
    width: 20%;
    text-align: center;
  }

  .acc_box ul li p {
    text-align: center;
    line-height: 36px;
    height: 36px;
    font-size: 14px;
  }

  .acc_box ul li img {
    width: 90px;
    height: 120px;
  }

  .rescue_box {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .rescue_box>p {
    line-height: 40px;
    font-size: 14px;
  }

  .res_div {
    position: relative;
    top: 18px;
  }

  .res_box {
    position: relative;
    top: 20px;
    font-size: 14px;
    color: #999;
  }

  .el-checkbox-group {
    position: relative;
    box-sizing: border-box;
    padding: 0 15px;
  }

  .el-checkbox {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0;
  }

  .db_div,
  .res_div {
    font-size: 14px;
    color: #333;
  }

  .db_box {
    font-size: 14px;
    color: #333;
    margin-left: 30px;
  }

  .db_box b {
    color: #ff7200;
    margin-left: 8px;
  }

  .upbtn_box {
    text-align: center;
    margin-top: 0;
  }

  .gl {
    overflow: hidden;
    margin-bottom: 20px;
  }

  .gl li {
    float: left;
    margin-right: 10px;
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/starsdetail.vue